"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleStretchToFullWidth = void 0;
var handleStretchToFullWidth = function (_a) {
    var _b;
    var value = _a.value, onChange = _a.onChange, id = _a.id, enableColActions = _a.enableColActions, addColButtonWidth = _a.addColButtonWidth, fullWidthCompWrapper = _a.fullWidthCompWrapper;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var totalAvailableWidth = ((_b = fullWidthCompWrapper.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width) -
        (enableColActions ? addColButtonWidth : 0);
    var noOfCols = data[0].cellData.length;
    var widthPerCol = totalAvailableWidth / noOfCols + "px";
    var newColWidthConfig = Object.keys(colWidthConfig)
        .map(function (k) { return ({
        colId: k,
        width: widthPerCol,
    }); })
        .reduce(function (a, b) {
        var _a;
        return (__assign(__assign({}, a), (_a = {}, _a[b.colId] = b.width, _a)));
    }, {});
    onChange && onChange(id, { data: data, colWidthConfig: newColWidthConfig });
};
exports.handleStretchToFullWidth = handleStretchToFullWidth;
